import moment from "moment";
import FileTypeCell from "../../../../../common/FileTypeCell/FileTypeCell";
import ActionsCell from "../../../../../common/ActionsCell/ActionsCell";

const DocumentsGridColumnDefs = [
  {
    headerName: 'Type',
    headerClass: ['grid-header'],
    field: 'documentType',
    maxWidth: 300
  },
  {
    headerName: 'Name',
    headerClass: ['grid-header'],
    field: 'documentName',
    valueGetter: params => {
      return params.data.documentName.replace('.pdf', '');
    },
    minWidth: 300
  },
  {
    headerName: 'Last Updated',
    headerClass: ['grid-header'],
    field: 'displayDate',
    valueGetter: params => {
      return params?.data?.displayDate === null || params?.data?.displayDate == undefined ? "-" : moment(params?.data?.displayDate).format("DD MMM YYYY");
    },
    maxWidth: 150
  },
  {
    headerName: 'File Type',
    headerClass: ['grid-header'],
    field: 'fileFormat',
    cellRendererFramework: FileTypeCell,
    cellRendererParams: params => {
      return {
        showIcon: true,
        iconType: params.data?.fileFormat === null ? 'pdf' : params.data?.fileFormat
      }
    },
    maxWidth: 80
  },
  {
    headerName: 'Action',
    headerClass: ['grid-header'],
    field: 'fileFormat',
    cellRendererFramework: ActionsCell,
    cellRendererParams: params => {
      return {
        showTearOut: params?.data?.fileFormat !== 'pdf' ? false : true,
        showDownload: params?.data?.fileFormat === 'pdf' ? false : true,
        documentName: params?.data?.documentName,
        documentType: 'DOCUMENT',
        fileFormat: params?.data?.fileFormat === null ? 'pdf' : params?.data?.fileFormat,
      }
    },
    maxWidth: 70
  }
]

export default DocumentsGridColumnDefs
